import { render, staticRenderFns } from "./categoryParams.vue?vue&type=template&id=e7843e90&scoped=true&"
import script from "./categoryParams.vue?vue&type=script&lang=js&"
export * from "./categoryParams.vue?vue&type=script&lang=js&"
import style0 from "./categoryParams.vue?vue&type=style&index=0&id=e7843e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7843e90",
  null
  
)

export default component.exports